import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { DashboardLayout } from "@/pages/Dashboard";
import { useLanguage, useAuth, API } from "@/App";
import { Badge } from "@/components/ui/badge";
import { MessageCircle, User, Home, Car } from "lucide-react";

export default function ChatInbox() {
  const { t } = useLanguage();
  const { token } = useAuth();
  const navigate = useNavigate();
  const [convs, setConvs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/chat/conversations`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setConvs(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [token]);

  return (
    <DashboardLayout title={t("صندوق الرسائل", "Inbox")}>
      <div className="max-w-3xl space-y-3" data-testid="chat-inbox">
        <div className="flex items-center gap-2 text-slate-400 text-sm">
          <MessageCircle size={16} />
          <span>{t("محادثاتك المباشرة مع ملاك الإعلانات", "Your direct chats with listing owners")}</span>
        </div>
        {loading ? (
          <div className="glass-card rounded-2xl h-40 skeleton" />
        ) : convs.length === 0 ? (
          <div className="glass-card rounded-2xl p-12 text-center text-slate-400">
            {t("لا توجد محادثات بعد. ابدأ بالتواصل من صفحات الإعلانات.", "No chats yet. Start by contacting an owner from a listing page.")}
          </div>
        ) : (
          <div className="glass-card rounded-2xl divide-y divide-slate-800">
            {convs.map((c) => (
              <button
                key={c.conversation_id}
                onClick={() => navigate(`/chat/conversation/${c.conversation_id}`)}
                className="w-full text-right p-4 flex items-center gap-3 hover:bg-slate-900/50 transition-colors"
                data-testid={`conv-${c.conversation_id}`}
              >
                <div className="w-12 h-12 rounded-full bg-yellow-500 text-black flex items-center justify-center font-bold flex-shrink-0">
                  <User size={20} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <h4 className="font-semibold text-white truncate">{c.other_user_name}</h4>
                    {c.listing_type === "property" && <Home size={12} className="text-yellow-500" />}
                    {c.listing_type === "vehicle" && <Car size={12} className="text-yellow-500" />}
                    {c.listing_title && <span className="text-xs text-slate-500 truncate">· {c.listing_title}</span>}
                  </div>
                  <p className="text-sm text-slate-400 truncate">{c.last_message}</p>
                </div>
                <div className="text-left flex flex-col items-end gap-1 flex-shrink-0">
                  <span className="text-xs text-slate-500">{new Date(c.updated_at).toLocaleDateString()}</span>
                  {c.unread_count > 0 && (
                    <Badge className="bg-yellow-500 text-black">{c.unread_count}</Badge>
                  )}
                </div>
              </button>
            ))}
          </div>
        )}
        <Link to="/chat" className="block text-center text-slate-500 hover:text-yellow-500 text-sm">
          {t("هل تبحث عن غرف المجتمع؟ اذهب إلى غرف المحادثة", "Looking for community rooms? Go to chat rooms")}
        </Link>
      </div>
    </DashboardLayout>
  );
}
